import { createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';


export const updateSetting = createApiAction(
  types.UPDATE_SETTING,
  (payload) => api.updateSetting(payload),
);

export const resetAccessKeys = createApiAction(
  types.RESET_ACCESS_KEYS,
  (payload) => api.resetAccessKeys(payload),
);

export const getSamlSettings = createApiAction(
  types.GET_SAML_SETTINGS,
  (payload) => api.getSamlSettings(payload),
  { meta: { skipErrorPage: true } },
);

export const deleteSamlFile = createApiAction(
  types.DELETE_SAML_FILE,
  (payload) => api.deleteSamlFile(payload),
);

export const updateSamlSettings = createApiAction(
  types.UPDATE_SAML_SETTINGS,
  (payload) => api.postSamlSettings(payload),
);

export const patchUSSettings = createApiAction(
  types.PATCH_US_SSO_SETTINGS,
  (payload) => api.patchUSSettings(payload),
);

export const getOrganization = createApiAction(
  types.GET_ORGANIZATION,
  (payload) => api.getOrganization(payload),
);
